import React  from "react";
import { Spin,Skeleton } from "antd";
export function PageLoading({ children, loading }) {
  return (
    <Spin tip="Cargando..." size="large" spinning={loading}> 
      {children} 
    </Spin>
  );
}
export function SkeletonLoading({ children, loading }) {  
  return ( 
      <Skeleton loading={loading} paragraph={{ rows: 5 }}  >
        {children}
      </Skeleton> 
  );
}
export function Loading({ children, loading }) {
  return (
    <Spin tip="Cargando..." size="large" spinning={loading}>
      <Skeleton loading={loading} paragraph={{ rows: 5 }}>
        {children}
      </Skeleton>
    </Spin>
  );
}